import React from "react"
import { Navigate } from "react-router-dom"
import { useSelector } from "react-redux"
import VerticalLayout from "components/VerticalLayout"
import HorizontalLayout from "components/HorizontalLayout"

//constants
import { layoutTypes } from "../../constants/layout"

const Adminmiddleware = props => {
  const layoutType = useSelector(state => state.Layout.layoutType)
  const token = useSelector(state => state.auth.token)
  const user = useSelector(state => state.auth.user)

  const getLayout = layoutType => {
    let Layout = VerticalLayout
    switch (layoutType) {
      case layoutTypes.VERTICAL:
        Layout = VerticalLayout
        break
      case layoutTypes.HORIZONTAL:
        Layout = HorizontalLayout
        break
      default:
        break
    }
    return Layout
  }

  if (process.env.REACT_APP_IS_LIVE === "true") {
    if (token === null) {
      console.log("in auth middleware if")
      return (
        <Navigate to="/login" replace />
      )
    } else if (user?.user_type === "user") {
      console.log("Invalid Admin panel user")
      return <Navigate to="/unauthorized" replace />
    }
  }

  const Layout = getLayout(layoutType)

  return (
    <React.Fragment>
      <Layout>{props.children}</Layout>
    </React.Fragment>
  )
}

export default Adminmiddleware
